export default __webpack_public_path__ + "static/media/leadlovers-marca.5c0e0512.svg";